theme.tiktokSwiper = (function() {
document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".carousel-track");
  const cards = Array.from(document.querySelectorAll(".carousel-card"));
  const leftArrow = document.querySelector(".nav-arrow-left");
  const rightArrow = document.querySelector(".nav-arrow-right");

  // Índice do card ativo (começa no primeiro)
  let activeIndex = 0;

  cards.forEach((card, index) => {
    const video = card.querySelector("video");
    const muteBtn = card.querySelector(".mute-btn");
    const playBtn = card.querySelector(".play-btn");

    if (!video) return;

    // Evita múltiplos listeners
    if (!muteBtn.dataset.listenerAttached) {
      muteBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        console.log(video.muted, activeIndex, index);
        muteBtn.classList.toggle("active", !video.muted);
        if (!video.muted && activeIndex !== index) {
          activeIndex = index;
          updateCards();
        }
      });
      muteBtn.dataset.listenerAttached = "true";
    }

    if (!playBtn.dataset.listenerAttached) {
      playBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        if (activeIndex !== index) {
          activeIndex = index;
          updateCards();
        } else {
          if (video.paused) {
            video.play().catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          } else {
            video.pause();
          }
          playBtn.classList.toggle("active", !video.paused);
        }
      });
      playBtn.dataset.listenerAttached = "true";
    }
  });

  // Atualiza classes de posição e estado dos vídeos
  function updateCards() {
    cards.forEach((card, i) => {
      card.classList.remove("active", "left-1", "left-2", "right-1", "right-2");

      const offset = normalizeOffset(i - activeIndex, cards.length);

      // Mapeamento de posições visíveis
      if (offset === 0) {
        card.classList.add("active");
        playCardVideo(card);
      } else if (offset === -1) {
        card.classList.add("left-1");
        pauseCardVideo(card);
      } else if (offset === -2) {
        card.classList.add("left-2");
        pauseCardVideo(card);
      } else if (offset === 1) {
        card.classList.add("right-1");
        pauseCardVideo(card);
      } else if (offset === 2) {
        card.classList.add("right-2");
        pauseCardVideo(card);
      } else {
        // Demais invisíveis
        pauseCardVideo(card);
      }
    });
  }

  // Normaliza offset com wrap (ex.: últimos itens à esquerda)
  function normalizeOffset(offset, len) {
    // Traz offset para o intervalo [-len/2 .. len/2]
    const half = Math.floor(len / 2);
    while (offset > half) offset -= len;
    while (offset < -half) offset += len;
    return offset;
  }

  function playCardVideo(card) {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".play-btn");
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }
    if (playBtn) playBtn.classList.add("active");
  }

  function pauseCardVideo(card) {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".play-btn");
    if (!video) return;
    video.pause();
    if (playBtn) playBtn.classList.remove("active");
  }

  // Navegação infinita
  function nextCard() {
    activeIndex = (activeIndex + 1) % cards.length;
    updateCards();
  }

  function prevCard() {
    activeIndex = (activeIndex - 1 + cards.length) % cards.length;
    updateCards();
  }

  if (rightArrow) rightArrow.addEventListener("click", nextCard);
  if (leftArrow) leftArrow.addEventListener("click", prevCard);

  // Opcional: setas por teclado
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") nextCard();
    if (e.key === "ArrowLeft") prevCard();
  });

  // Inicializa
  updateCards();
});
});
// ...
theme.tiktokSwiper();